import { TIME_LINE_MODE } from '@constants'
import {
  ObjectDataRecord,
  POSTObjectDataFilter,
  TimeLineDTOType,
  TimeLineGridDataRecord,
} from '@types'

import { groupByObject } from './group/groupByObject'
import { groupByTimeIntervals } from './group/groupByTimeIntervals'
import { groupDataByMainObject } from './group/groupDataByMainObject'
import { groupObjectXListByObjectYElement } from './group/groupObjectXListByObjectYElement'
import { DateInterval } from './splitIntervalByPeriod'

type Props = {
  config: TimeLineDTOType
  dateIntervals: DateInterval[]
  objectXData: ObjectDataRecord[]
  objectYData: ObjectDataRecord[]
  columnsObjectData?: ObjectDataRecord[]
  handleChangeTimeLineGridData: (
    data: TimeLineGridDataRecord[],
    isRefresh?: boolean,
    objectXData?: ObjectDataRecord[]
  ) => void
  handleChangeColumnsObjectData: (objectData: ObjectDataRecord[]) => void
  isInitialLoad: boolean
  keyFieldY: string
  objectXSAFiltersCriteria: POSTObjectDataFilter
}

export const convertApiResponseToTimeLineGridData = (props: Props) => {
  const {
    config,
    dateIntervals,
    objectXData,
    objectYData,
    columnsObjectData,
    handleChangeTimeLineGridData,
    handleChangeColumnsObjectData,
    isInitialLoad,
    keyFieldY,
    objectXSAFiltersCriteria,
  } = props

  // TODO проверить группировку
  if (config.mainObject?.groupField?.length && config.mode === TIME_LINE_MODE.DATE_TIME) {
    const rows = groupDataByMainObject({
      config,
      dateIntervals,
      objectXData,
      objectYData,
    })

    handleChangeTimeLineGridData(rows, true)

    return
  }

  // Сгруппированные данные
  const groupedData = groupObjectXListByObjectYElement(config, objectYData, objectXData)

  if (config.mode === TIME_LINE_MODE.DATE_TIME && config.objectX.startDateField) {
    // Готовые данные для таблицы, сформированные на основе временных интервалов
    const groupedDataByTimeIntervals = groupByTimeIntervals(
      groupedData,
      dateIntervals,
      config.objectX.startDateField,
      keyFieldY
    )

    handleChangeTimeLineGridData(groupedDataByTimeIntervals, isInitialLoad, objectXData)

    return
  }

  if (config.mode === TIME_LINE_MODE.OBJECT && columnsObjectData) {
    const groupedDataByObject = groupByObject({
      groupedData,
      objectYKeyField: keyFieldY,
      config,
      columnsObjectData,
    })

    handleChangeColumnsObjectData(
      config.filterColumnsObjectByObjectX && Boolean(objectXSAFiltersCriteria?.length)
        ? [...columnsObjectData]
        : columnsObjectData
    )

    handleChangeTimeLineGridData(groupedDataByObject, isInitialLoad, objectXData)
  }
}
